module.exports = __webpack_public_path__ + "static/media/picto-pencil-black.6960b702.svg";